@if (showHeader$ | async) {
  <div class="border-b-steel-20 flex h-16 w-full items-center justify-between border-b px-6 md:border-0">
    <a href="/">
      <img class="h-10" [src]="'logos/logo-dark.svg' | staticImageUrl" alt="FindMyAgent" />
    </a>
    <div class="flex items-center">
      @if (showRestore$ | async) {
        @if (store.savedCriteria$ | async; as params) {
          <button (click)="onRestore(params)" type="button" mat-flat-button color="primary" data-id="restore">
            {{ 'findMyAgent.persistence.restore' | transloco }}
          </button>
        }
      }
      @if ((isStepPage$ | async) !== true) {
        <rma-share-button [data]="shareData$ | async" />
      }
      <a class="ml-2" href="/">
        <rma-icon class="mt-2" glyph="clear" />
      </a>
    </div>
  </div>
}

<div class="mx-auto p-3 md:max-w-3xl md:p-0">
  @if (showBackButton$ | async) {
    <button (click)="stepBack()" type="button" buttonType="responsive" mat-button color="primary" data-id="back-button">
      <rma-icon glyph="arrow_back" /> {{ 'findMyAgent.button.back' | transloco }}
    </button>
  }
</div>
<div [class]="contentStyle$ | async">
  @if (showStepper$ | async) {
    <div
      class="text-steel-70 mb-2"
      [innerHTML]="'findMyAgent.stepper.step' | transloco: { step: stepNumber$ | async, steps: stepTotal }"></div>
  }
  <router-outlet />
</div>
